import React, { useState } from 'react';
import PropTypes from 'prop-types';

// Components
import { TooltipLoader } from '../../global/TooltipLoader';
import { FormattedMessage } from 'react-intl';
import InvoiceIcon from 'dibs-icons/exports/Pdf';

// helpers
import { getInvoiceHref } from '../helpers/getInvoiceHref';
import { trackEvent } from 'dibs-tracking';

import styles from './PdpRespIconBubbles.scss';

export function PdpRespIconBubbleInvoice({ itemId, skuId }) {
    const [isTooltipShowing, setIsTooltipShowing] = useState(false);

    function hideTooltip() {
        setIsTooltipShowing(false);
    }

    function openLink() {
        hideTooltip();
        trackEvent({
            category: 'product',
            action: 'view invoice',
            label: 'PDP trade',
        });
        window.open(getInvoiceHref(itemId, skuId));
    }

    return (
        <div
            data-tn="icon-bubble-invoice"
            className={styles.bubble}
            onClick={openLink}
            onMouseEnter={() => setIsTooltipShowing(true)}
            onMouseLeave={hideTooltip}
        >
            <InvoiceIcon className={styles.icon} />
            <TooltipLoader
                load={isTooltipShowing}
                isVisible={isTooltipShowing}
                closeOnOutsideClick
                onClose={hideTooltip}
            >
                <FormattedMessage
                    id="PdpRespIconBubbleInvoice.generate"
                    defaultMessage="Generate an invoice that you can customize and print."
                />
            </TooltipLoader>
        </div>
    );
}

PdpRespIconBubbleInvoice.propTypes = {
    itemId: PropTypes.string.isRequired,
    skuId: PropTypes.string,
};
